import { Box, Flex, Text } from "@chakra-ui/react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { BiCircle } from "react-icons/bi";
import { MdModeComment } from "react-icons/md";

import { FieldDescription } from "./field-description";
import { PartialScenarioReview } from "./quality-control-types";

interface SingleQualityControlItemProps {
  wholeReview: PartialScenarioReview;
  field: keyof PartialScenarioReview;
  setEditing(field: keyof PartialScenarioReview): void;
  editable: boolean;
}

export function SingleQualityControlItem({
  wholeReview,
  field,
  setEditing,
  editable,
}: SingleQualityControlItemProps) {
  const review = wholeReview[field];

  return (
    <Flex
      border="1px solid #ccc"
      rounded="md"
      p="12px"
      alignItems="center"
      my="12px"
      _hover={{
        cursor: editable ? "pointer" : undefined,
      }}
      onClick={() => setEditing(field)}
    >
      <Box p="4px">
        {review.ok === true ? (
          <AiOutlineCheckCircle color="green" size="22px" />
        ) : review.ok === false ? (
          <AiOutlineCloseCircle color="red" size="22px" />
        ) : (
          <BiCircle color="#ccc" size="22px" />
        )}
      </Box>
      <Box p="4px">
        <Text fontWeight="normal">
          <FieldDescription field={field} />
        </Text>
        {review.comment ? (
          <Flex alignItems="center">
            <MdModeComment color="#B8B7B7" />
            <Text fontSize="sm" ml="4px">
              {review.comment}
            </Text>
          </Flex>
        ) : null}
      </Box>
    </Flex>
  );
}
